import { createBrowserHistory } from 'history';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;

const history = createBrowserHistory({ basename: baseUrl });

const navigateToPage = (url: string) => history.push(url);

export { history, navigateToPage }